var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"columns is-multiline is-mobile"},[_c('Title'),(_vm.visible)?_c('div',{staticClass:"page__actions column"},[_vm._t("default")],2):_vm._e(),_c('Weather',{attrs:{"bordered":_vm.bordered}}),_c('Notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }